import { LocalizationEndpoints } from '@/modules/preference/localization/api/localizationEndpoints'

/**
 * Localization endpoint instance
 * instantiate localization api class with different api path
 */

export const localizationEndpoints = new LocalizationEndpoints()
